import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { X, Sparkles } from 'lucide-react';

// Slim site-wide banner promoting the newest program: Girls Flag Football.
// One-tap Express Interest link -> /girls-flag landing page.
// Sits ABOVE the fixed .network-header via z-index; toggles a body class
// (`banner-visible`) so the header shifts down while it is on screen.
// Dismiss persists for the session, so parents see it again next visit.

const DISMISS_KEY = 'panthers_girls_flag_banner_dismissed';
const BODY_CLASS = 'banner-visible';

const WRAPPER_STYLE = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  background: 'linear-gradient(90deg, #FFD700 0%, #FFC500 50%, #FFD700 100%)',
  color: '#000',
  padding: '0.5rem 2.75rem 0.5rem 1rem',
  fontWeight: 700,
  fontSize: '0.88rem',
  letterSpacing: '0.3px',
  textAlign: 'center',
  boxShadow: '0 3px 12px rgba(255, 215, 0, 0.35)',
  zIndex: 10001,
};

const INNER_STYLE = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '0.55rem',
};

const CTA_STYLE = {
  background: '#000',
  color: '#FFD700',
  padding: '0.28rem 0.85rem',
  borderRadius: '999px',
  fontSize: '0.75rem',
  fontWeight: 900,
  letterSpacing: '1px',
  textTransform: 'uppercase',
  textDecoration: 'none',
  whiteSpace: 'nowrap',
};

const CLOSE_BTN_STYLE = {
  position: 'absolute',
  top: '50%',
  right: '0.55rem',
  transform: 'translateY(-50%)',
  background: 'transparent',
  border: 'none',
  color: '#000',
  cursor: 'pointer',
  padding: '0.25rem',
  display: 'inline-flex',
  alignItems: 'center',
  opacity: 0.75,
};

const RecruitBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!sessionStorage.getItem(DISMISS_KEY)) setVisible(true);
  }, []);

  useEffect(() => {
    if (visible) {
      document.body.classList.add(BODY_CLASS);
    } else {
      document.body.classList.remove(BODY_CLASS);
    }
    return () => document.body.classList.remove(BODY_CLASS);
  }, [visible]);

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={WRAPPER_STYLE} data-testid="recruit-banner">
      <span style={INNER_STYLE}>
        <Sparkles size={16} strokeWidth={2.5} />
        <span>NEW · Girls Flag Football · Ages 12-14</span>
        <Link
          to="/girls-flag"
          style={CTA_STYLE}
          data-testid="recruit-banner-cta"
        >
          Express Interest →
        </Link>
      </span>
      <button
        onClick={dismiss}
        style={CLOSE_BTN_STYLE}
        aria-label="Dismiss announcement"
        data-testid="recruit-banner-dismiss"
      >
        <X size={16} strokeWidth={2.5} />
      </button>
    </div>
  );
};

export default RecruitBanner;
